import React from 'react';

const SIZE_CLASSES = {
  sm: 'w-5 h-5',
  md: 'w-8 h-8',
  lg: 'w-16 h-16',
};

export default function LoadingSpinner({ size = 'md', className = '', ringClassName = '' }) {
  const spinnerSize = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <div className={`relative ${spinnerSize} ${className}`}>
      <div className={`absolute inset-0 border-2 border-dd-lime border-t-transparent rounded-full animate-spin ${ringClassName}`} />
    </div>
  );
}
